import React from "react";
import { GrEmptyCircle } from "react-icons/gr";

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  titleProps?: React.HTMLAttributes<HTMLHeadingElement>;
  descriptionProps?: React.HTMLAttributes<HTMLParagraphElement>;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  titleProps,
  descriptionProps,
}) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "2rem",
      color: "#888",
    }}
  >
    <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>
      {icon || <GrEmptyCircle color="grey" />}
    </div>
    <h2
      style={{ margin: 0, fontSize: "1.5rem" }}
      {...titleProps}
    >
      {title}
    </h2>
    {description && (
      <p
        style={{
          marginTop: "0.5rem",
          fontSize: "1rem",
          textAlign: "center",
          maxWidth: 400,
        }}
        {...descriptionProps}
      >
        {description}
      </p>
    )}
  </div>
);

export default EmptyState;
